import type { GrafanaExplorerTargetKind } from '@app/config/grafanaExplorerCatalog';

export interface MockGrafanaTargetOption {
  siteId: string;
  deviceName: string;
  targetId: string;
  targetLabel: string;
  targetKind: GrafanaExplorerTargetKind;
}

export const MOCK_GRAFANA_TARGETS_BY_SITE: Record<string, MockGrafanaTargetOption[]> = {
  'site-sfo': [
    {
      siteId: 'site-sfo',
      deviceName: 'Edge-West-1.example.com',
      targetId: 'ref:inventory.interface:11111111-1111-4111-8111-111111111111#Po10',
      targetLabel: 'Po10 @ Edge-West-1.example.com',
      targetKind: 'lag'
    },
    {
      siteId: 'site-sfo',
      deviceName: 'Edge-West-1.example.com',
      targetId: 'ref:inventory.interface:11111111-1111-4111-8111-111111111111#Te1/0/3',
      targetLabel: 'Te1/0/3 @ Edge-West-1.example.com',
      targetKind: 'interface'
    },
    {
      siteId: 'site-sfo',
      deviceName: 'Edge-West-1.example.com',
      targetId: 'ref:inventory.interface:11111111-1111-4111-8111-111111111111#Te1/0/4',
      targetLabel: 'Te1/0/4 @ Edge-West-1.example.com',
      targetKind: 'interface'
    },
    {
      siteId: 'site-sfo',
      deviceName: 'Dist-West-1.example.com',
      targetId: 'ref:inventory.interface:22222222-2222-4222-8222-222222222222#Po20',
      targetLabel: 'Po20 @ Dist-West-1.example.com',
      targetKind: 'lag'
    },
    {
      siteId: 'site-sfo',
      deviceName: 'Dist-West-1.example.com',
      targetId: 'ref:inventory.interface:22222222-2222-4222-8222-222222222222#Te1/0/7',
      targetLabel: 'Te1/0/7 @ Dist-West-1.example.com',
      targetKind: 'interface'
    }
  ],
  'site-nyc': [
    {
      siteId: 'site-nyc',
      deviceName: 'Core-East-1.example.com',
      targetId: 'ref:inventory.interface:33333333-3333-4333-8333-333333333333#Po30',
      targetLabel: 'Po30 @ Core-East-1.example.com',
      targetKind: 'lag'
    },
    {
      siteId: 'site-nyc',
      deviceName: 'Core-East-1.example.com',
      targetId: 'ref:inventory.interface:33333333-3333-4333-8333-333333333333#Te1/0/11',
      targetLabel: 'Te1/0/11 @ Core-East-1.example.com',
      targetKind: 'interface'
    },
    {
      siteId: 'site-nyc',
      deviceName: 'Campus-Agg-2.example.com',
      targetId: 'ref:inventory.interface:44444444-4444-4444-8444-444444444444#Po12',
      targetLabel: 'Po12 @ Campus-Agg-2.example.com',
      targetKind: 'lag'
    },
    {
      siteId: 'site-nyc',
      deviceName: 'Campus-Agg-2.example.com',
      targetId: 'ref:inventory.interface:44444444-4444-4444-8444-444444444444#Te1/0/2',
      targetLabel: 'Te1/0/2 @ Campus-Agg-2.example.com',
      targetKind: 'interface'
    }
  ],
  'site-ams': [
    {
      siteId: 'site-ams',
      deviceName: 'Ams-Edge-1.example.com',
      targetId: 'ref:inventory.interface:55555555-5555-4555-8555-555555555555#Po8',
      targetLabel: 'Po8 @ Ams-Edge-1.example.com',
      targetKind: 'lag'
    },
    {
      siteId: 'site-ams',
      deviceName: 'Ams-Edge-1.example.com',
      targetId: 'ref:inventory.interface:55555555-5555-4555-8555-555555555555#Te1/0/5',
      targetLabel: 'Te1/0/5 @ Ams-Edge-1.example.com',
      targetKind: 'interface'
    }
  ]
};
